<template>
  <div class="splash-screen">
    <svg
      class="app-logo-splash-screen"
      version="1.1"
      id="svg1"
      width="345.60001"
      height="345.60001"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:svg="http://www.w3.org/2000/svg"
    >
      <defs id="defs1">
        <linearGradient id="swatch1">
          <stop style="stop-color: #000000; stop-opacity: 1" offset="0" id="stop1" />
        </linearGradient>
      </defs>

      <g id="g1">
        <path
          class="draw-effect"
          style="
            fill: #000000;
            fill-opacity: 0;
            stroke: #3366ff;
            stroke-width: 10;
            stroke-linejoin: miter;
            stroke-dasharray: none;
            stroke-opacity: 1;
          "
          d="m 143.61933,125.98318 c 5.87872,0 6.39905,0.0372 10.04592,0 3.05082,-0.0311 8.55765,-0.0623 11.60861,-0.0744 3.12547,-0.0124 6.39953,0.0124 9.525,2e-5 2.87733,-0.0114 5.5563,0.0148 8.3344,0 2.33174,-0.0124 4.66414,-0.14229 6.99492,-0.0744 2.16223,0.063 4.32205,0.22711 6.47404,0.44648 2.76402,0.28176 5.52786,0.61141 8.25996,1.11621 1.27796,0.23613 2.53397,0.57926 3.79512,0.89297 1.51801,0.37761 3.25685,0.72324 4.53927,1.19063 1.17292,0.42748 2.63339,0.80804 3.79513,1.26504 1.2945,0.50922 2.60001,0.99405 3.86953,1.5627 1.94379,0.87068 3.84342,1.83898 5.72989,2.82774 1.13097,0.59278 2.1354,1.14418 3.34865,1.86035 1.04297,0.61565 2.43256,1.38664 3.42304,2.0836 1.01875,0.71685 2.07292,1.38657 3.05098,2.15801 1.47668,1.16474 2.82404,2.48471 4.24161,3.72071 1.48442,1.29429 4.46485,3.86953 4.46485,3.86953 0,0 4.67928,4.91026 6.8461,7.51583 1.23394,1.4838 2.3932,3.03101 3.49747,4.61368 1.0788,1.54617 2.09049,3.14019 3.05098,4.76251 0.7917,1.33722 1.54878,2.69722 2.23242,4.09278 0.84539,1.72574 1.57874,3.50499 2.30684,5.2834 0.8151,1.99091 1.62288,3.98787 2.30684,6.02755 0.99334,2.9623 1.90982,5.95791 2.6045,9.00411 0.53131,2.32982 0.76921,4.47207 1.04179,6.84611 0.27498,2.39492 0.57088,5.03088 0.59532,7.44141 0.0244,2.4076 -0.0925,4.81816 -0.2997,7.21695 -0.23141,2.67902 -0.58487,5.35001 -1.05238,7.99805 -0.44983,2.54791 -1.02691,5.07457 -1.6838,7.5771 -0.52122,1.98569 -1.06954,3.97056 -1.78904,5.8933 -0.78143,2.08825 -1.73088,4.1136 -2.73617,6.10378 -1.54392,3.0565 -3.23302,6.04357 -5.0514,8.94519 -1.17812,1.87995 -2.44217,3.70898 -3.78855,5.47235 -1.3901,1.82063 -2.88172,3.56457 -4.41998,5.26187 -1.44928,1.59913 -2.9655,3.13883 -4.52521,4.63045 -1.59798,1.52821 -3.24815,3.00375 -4.94617,4.41998 -1.53576,1.2809 -3.09455,2.54052 -4.73568,3.68331 -1.96514,1.36842 -4.02608,2.59795 -6.10378,3.78855 -1.89243,1.08444 -3.8041,2.14568 -5.78806,3.05189 -2.02057,0.92293 -6.20902,2.42046 -6.20902,2.42046 0,0 -4.46471,1.49042 -6.7352,2.10475 -2.11926,0.57341 -4.24932,1.14104 -6.41949,1.47333 -1.77386,0.27161 -3.57642,0.45245 -5.36711,0.56978 -2.66399,0.17455 -5.18007,0.14302 -7.84922,0.19771 -3.01638,0.0618 -1.01714,-0.0308 -9.19926,-0.0308"
          id="path5"
        />
        <path
          class="draw-effect"
          style="
            fill: #000000;
            fill-opacity: 0;
            stroke: #3366ff;
            stroke-width: 10;
            stroke-linejoin: miter;
            stroke-dasharray: none;
            stroke-opacity: 1;
          "
          d="m 76.795415,199.42995 64.875835,0.30426 c 0,0 9.21559,-0.14754 14.08027,-0.30911 3.64869,-0.12118 7.99245,-0.49197 12.56274,-1.06247 3.6688,-0.45797 8.30228,-1.63435 12.36333,-2.80221 3.32216,-0.95537 6.61646,-2.05214 9.78655,-3.43054 3.81426,-1.65849 7.56157,-3.53096 11.04941,-5.79682 3.48759,-2.2657 6.53254,-4.88853 9.78655,-7.73907 3.64173,-3.19019 6.79641,-6.37345 9.69938,-9.99703 2.83147,-3.53432 5.26902,-7.39205 7.452,-11.35983 2.4438,-4.44186 4.62274,-9.06132 6.27632,-13.8538 1.39127,-4.03225 2.39047,-8.21528 3.03074,-12.43246 0.70388,-4.63626 0.88491,-9.35155 0.87491,-14.04093 -0.008,-4.05383 -0.13633,-8.13662 -0.80579,-12.1348 -0.75314,-4.49789 -2.05475,-8.907779 -3.58993,-13.202128 -1.63396,-4.570647 -3.59575,-9.046274 -5.95313,-13.289312 -2.15013,-3.869995 -4.63695,-7.572986 -7.42337,-11.013296 -2.60564,-3.217098 -5.50755,-6.2137 -8.63204,-8.929699 -4.07404,-3.541409 -8.47833,-6.730682 -13.09689,-9.525013 -4.25625,-2.575128 -8.51604,-4.921384 -13.3765,-6.617571 -5.43819,-1.897803 -11.36641,-3.325099 -17.07166,-4.116124 -4.6358,-0.642749 -9.8384,-0.511668 -14.51605,-0.664439 -5.05844,-0.16521 -14.86478,0.08718 -14.86478,0.08718"
          id="path6"
        />
        <path
          class="draw-effect"
          style="fill: none; stroke: #3366ff; stroke-width: 10; stroke-opacity: 1"
          d="m 72.181736,37.504737 67.489134,-0.11349 -0.0699,247.912643 H 77.093071 L 77.241899,41.969587"
          id="path3"
        />
      </g>
    </svg>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  props: {},
  setup() {
    return {};
  }
});
</script>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>

<style lang="scss">
@import "./public/styles/variables.scss";
.splash-screen {
  color: $selected-color;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .app-logo-splash-screen {
    box-shadow: -1px 0px 25px 50px rgba(51, 102, 255, 0.14);
    background: transparent;
    border-radius: 45px;
    .draw-effect {
      stroke-dasharray: 700;
      stroke-dashoffset: 700;
      animation: draw-effect-frames 2s ease-in forwards;
      will-change: stroke-dashoffset;
    }

    @keyframes draw-effect-frames {
      from {
        stroke-dasharray: 700;
        stroke-dashoffset: 700;
      }
      to {
        stroke-dasharray: 700;
        stroke-dashoffset: 0;
      }
    }
  }
}
</style>
